module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG0007-ad61a7ce47d8a99b4b52dd954ad07a26.png";